import { useEscapeById, useModal } from 'shared/lib/modal';
import { ButtonOutlined } from '../buttons/buttonOutlined';
import { ModalCard } from '../cards/modalCard';
import { Flex } from '../flex';
import { Typography } from '../typography';
import { ButtonsContainer, Circle, MarginBottom } from './styles';
import { Img } from '../imgStyledComponent';
import marker from 'assets/icons/exclamation-mark.svg';
import { FC, ReactNode, useEffect, useRef } from 'react';
import { ButtonContained } from '../buttons/buttonContained';

interface ConfirmProps {
	confirmButton?: ReactNode;
	cancelButtonLabel?: string;
	title: string;
	canClose?: boolean;
	onClose?: () => void;
	cancelButtonContained?: boolean;
	buttonsReversed?: boolean;
	showCancelButton?: boolean;
  text?: string | null;
}

export const Confirm: FC<ConfirmProps> = ({
	confirmButton,
	cancelButtonLabel = 'Нет',
	title,
	canClose = true,
	onClose,
	cancelButtonContained = false,
	buttonsReversed,
	showCancelButton = true,
  text
}) => {
	const { closeModal } = useModal();

	const close = () => {
		onClose?.();
		if (canClose) {
			closeModal();
		}
	};

  const isScreenSm = useRef(matchMedia(`(width >= 576px)`).matches);

  useEffect(() => {
    isScreenSm.current = matchMedia(`(width >= 576px)`).matches
  }, [])

	useEscapeById('confirm-modal')

	return (
		<ModalCard styles={{ cardVariant: 'default' }} onClose={close} zIndex={1001} id="confirm-modal">
			<MarginBottom>
				<Flex $justify="center">
					<Circle>
						<Img src={marker} $size="giant" />
					</Circle>
				</Flex>
			</MarginBottom>
			<MarginBottom $value="32px">
        <MarginBottom $value='10px'>
          <Flex $justify="center">
            <Typography
              mode={isScreenSm.current ? 'large' : 'medium'}
              isBold={isScreenSm.current}
              textAlignCenter={true}
              whiteSpace="break-spaces"
            >
              {title}
            </Typography>
          </Flex>
        </MarginBottom>
        {text && 
				<Flex $justify="center">
					<Typography textAlignCenter={true}>
						{text}
					</Typography>
				</Flex>
        }
			</MarginBottom>
			<ButtonsContainer>
				<Flex
					$justify="center"
					$direction={buttonsReversed ? 'column-reverse' : 'column'}
					$gap="15px"
				>
					{confirmButton ? (
						confirmButton
					) : (
						<ButtonOutlined>Да</ButtonOutlined>
					)}
					{showCancelButton && (
						<>
							{cancelButtonContained ? (
								<ButtonContained onClick={close}>
									{cancelButtonLabel}
								</ButtonContained>
							) : (
								<ButtonOutlined onClick={close}>
									{cancelButtonLabel}
								</ButtonOutlined>
							)}
						</>
					)}
				</Flex>
			</ButtonsContainer>
		</ModalCard>
	);
};
